<template>
  <div>
    <div>
      <b-btn variant="warning" block class="font-weight-bold" @click="openModal"
        >Change Tip
        <span v-if="$showApprove([3, 4, 5, 11, 12])">
          *
        </span>
      </b-btn>
      <approve-permission
        :orderId="order.OrderID"
        :tab-no="order.TabNo"
        action-type="ChangeTip"
        @acceptPermission="openWithAcceptPermission"
        v-model="approveModal"
      />
    </div>
    <Cmodal
      v-model="modal"
      cancel-label="Never mind"
      centered
      title="Change Tip"
      :tag="false"
      confirm-label="Save Tip Amount"
      :progressing="loading"
      size="lg"
      @submit="changeTip"
    >
      <template>
        <div>
          Note: New tip percentage applies to net subtotal, i.e. subtotal after any applied credit.
        </div>
        <div class="h4 font-weight-bold my-2">Tip Amount ($): ${{ calcTipValue }}</div>
        <ul class="percent my-3 mb-5 px-0 d-flex flex-row justify-content-between">
          <li
            v-for="(item, index) in tipes"
            class="py-2"
            :key="index"
            style="cursor:pointer"
            :class="item.selected ? 'activeTip' : ''"
            @click="selectTipPercentage(item)"
          >
            <span v-if="!item.value">
              ZERO
            </span>
            <span v-else>
              {{ item.text }}
            </span>
          </li>
        </ul>
      </template>
    </Cmodal>
  </div>
</template>

<script>
import Cmodal from './Cmodal'
import ApprovePermission from './approvePermission'
export default {
  name: 'updateTip',
  components: {
    ApprovePermission,
    Cmodal
  },
  props: {
    tip: {required: true},
    order: {required: true},
  },
  data() {
    return {
      modal: false,
      tipes: [
        {text: '0%', value: 0, selected: false},
        {text: '5%', value: 5, selected: false},
        {text: '10%', value: 10, selected: false},
        {text: '15%', value: 15, selected: false},
        {text: '20%', value: 20, selected: false},
        {text: '25%', value: 25, selected: false},
        {text: '30%', value: 30, selected: false},
        {text: '40%', value: 40, selected: false},
        {text: '50%', value: 50, selected: false}
      ],
      getTip: null,
      loading: false,
      approveModal: false,
      calcTipValue: 0
    }
  },
  computed: {
    getCurrentTip() {
      return this.tipes.find(item => item.selected)
    }
  },
  methods: {
    openModal() {
      if (this.$showApprove([3, 4, 5, 11, 12])) {
        this.approveModal = true
      } else {
        this.modal = true
        this.tipes.forEach(item => {
          if (item.value === this.order.Tip_Percentage.toFixed(2) * 100) {
            item.selected = true
            this.calcTip(item.value)
          } else {
            item.selected = false
          }
        })
      }
    },
    openWithAcceptPermission() {
      this.modal = true
      this.approveModal = false
      this.tipes.forEach(item => {
        if (item.value === this.order.Tip_Percentage.toFixed(2) * 100) {
          item.selected = true
          this.calcTip(item.value)
        } else {
          item.selected = false
        }
      })
    },
    showTip() {
      this.show = !this.show
      this.getTip = this.tip * 100
    },
    selectTipPercentage(tip) {
      this.tipes.forEach(item => {
        if (item.value === tip.value) {
          item.selected = true
          this.calcTip(item.value)
        } else {
          item.selected = false
        }
      })
    },
    changeTip() {
      let model = {
        RestaurantID: this.$store.state.selectedRestaurantId,
        OrderID: this.order.OrderID,
        TipPercent: this.getCurrentTip.value + '.00'
      }
      this.loading = true
      this.$api.diner.UpdateOrderTip(model).then(res => {
        this.loading = false
        if (res.success) {
          this.show = false
          this.modal = false
          this.$emit('changeTip')
        } else {
          this.$showError(res.message)
        }
      })
    },
    calcTip(val) {
      this.calcTipValue = ((this.order.Subtotal * val) / 100).toFixed(2)
    }
  }
}
</script>

<style scoped>
.percent {
  border: 1px solid rgba(176, 176, 176, 0.82);
}
.percent li {
  display: inline-block;
  list-style: none;
  width: 20%;
  text-align: center;
  border-right: 1px solid rgba(176, 176, 176, 0.82);
}
.percent li:hover {
  background: #e0b700;
}
.activeTip {
  background: #e0b700;
}
.percent li:last-child {
  border-right: none;
}
</style>
